import * as constActions from './WindowsEventsConstsActions';
import initialState from './WindowsEventsInitateState';

export default function WindowsEventsReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.INIT_DATA: {
      return Object.assign({}, state, {
        results: action.data
      });
    }
    case constActions.GET_COLUMNS: {
      return Object.assign({}, state, {
        columns: action.data
      });
    }
    case constActions.GET_HEADER_TO_DISPLAY: {
      return Object.assign({}, state, {
        headerColumns: action.data
      });
    }
    case constActions.FETCH_RESULTS: {
      return Object.assign({}, state, {
        results: action.data
      });
    }
    case constActions.WE_SAVE_PARAMETERS: {
      return Object.assign({}, state, {
        parameters: action.parameters
      });
    }
    case constActions.FETCH_EXISTING_RESULTS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.data]
      });
    }
    default:
      return state;
  }
}
